const dataSizeOptions = [
    { value: 0.5, label: 'Last Six Months' },
    { value: 1, label: 'Last Year' },
    { value: 2, label: 'Last Two Years' },
    { value: 3, label: 'Last Three Years' },
    { value: 0, label: 'All Time' },
];

export default dataSizeOptions;
